import {
    FETCH_CUSTOMER_TREATMENT_INCOME_REQUEST,
    FETCH_CUSTOMER_TREATMENT_INCOME_SUCCESS,
    FETCH_CUSTOMER_TREATMENT_INCOME_FAILURE,
  } from "./FetchCustomersTreatmentIncomeTypes";
  
  const initialState = {
    loading: false,
    customersTreatmentIncome: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CUSTOMER_TREATMENT_INCOME_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_CUSTOMER_TREATMENT_INCOME_SUCCESS:
        return {
          loading: false,
          customersTreatmentIncome: action.payload,
          error: "",
        };
      case FETCH_CUSTOMER_TREATMENT_INCOME_FAILURE:
        return {
          loading: false,
          customersTreatmentIncome: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  